import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useCertificates() {
  const getCertificate = async (certificateId) => {
    const result = await axios.get(
      `${apiUri}/api/v1/certificates/${certificateId}`
    );
    return result.data?.data;
  };

  const queryCertificate = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/certificates/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const createCertificate = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/certificates`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result?.data?.data;
  };

  const patchCertificate = async (certificateId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/certificates/${certificateId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data?.data;
  };

  const createCertificateRejections = async (certificateId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/certificates/${certificateId}/rejections`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return result?.data?.data;
  };

  const getCertificateRejections = async (certificateId) => {
    const result = await axios.get(
      `${apiUri}/api/v1/certificates/${certificateId}/rejections`
    );
    return result.data?.data;
  };

  const deleteCertificate = async (certificateId) => {
    const result = await axios.delete(
      `${apiUri}/api/v1/certificates/${certificateId}`,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return result.data?.data;
  };

  const uploadCertificate = async (certId, file) => {
    let data = new FormData();

    data.append("file", file, file.name);

    const result = await axios.patch(
      `${apiUri}/api/v1/certificates/${certId}/upload`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          maxBodyLength: Infinity,
        },
      }
    );

    return result?.data?.data;
  };

  return {
    getCertificate,
    queryCertificate,
    createCertificate,
    patchCertificate,
    createCertificateRejections,
    getCertificateRejections,
    deleteCertificate,
    uploadCertificate,
  };
}
